import { getFileExtension, getShareableFileUrl } from '@core/components/FileViewer/fileViewerPreviewUtils';
import { TMessageReference } from './types';

const SOURCE_LINK_EXTENSIONS = new Set(['html', 'htm']);
const PAGE_SUFFIX_PATTERN = /(\s*\(page\s+\d+\))\s*$/i;
const EXTENSION_PATTERN = /(\.[^./\\]+)$/;

export const isSourceLinkReference = (file: string): boolean => SOURCE_LINK_EXTENSIONS.has(getFileExtension(file));

export const getReferenceSourceUrl = (reference: TMessageReference): string => {
    const url = reference.sourceUrl || reference.file;
    return getShareableFileUrl(url) ? url.trim() : '';
};

const splitReferenceName = (name: string) => {
    const trimmedName = name.trim();
    const pageSuffix = trimmedName.match(PAGE_SUFFIX_PATTERN)?.[1] ?? '';
    const fileNameWithPath = trimmedName.replace(PAGE_SUFFIX_PATTERN, '');
    const fileName = fileNameWithPath.split(/[\\/]/).pop()?.trim() ?? '';
    const extension = fileName.match(EXTENSION_PATTERN)?.[1] ?? '';
    const stem = extension ? fileName.slice(0, -extension.length) : fileName;

    return { stem, extension, pageSuffix };
};

export const formatReferenceCitationName = (name: string, isSourceLink = false): string => {
    if (isSourceLink) return name.replace(PAGE_SUFFIX_PATTERN, '').trim();

    const { stem, extension, pageSuffix } = splitReferenceName(name);
    const shortenedName = `${stem.slice(0, 18)}..${extension}`;

    return `${shortenedName}${pageSuffix}`;
};

export const deriveReferenceDownloadFilename = (name: string | null | undefined): string => {
    if (!name?.trim()) {
        return 'document.pdf';
    }

    const { stem } = splitReferenceName(name);
    return stem ? `${stem}.pdf` : 'document.pdf';
};
